import { apiClient } from '@/lib/api-client';
import { ApiResponse } from '@/types';

/** Imagem da biblioteca de figuras da empresa (catálogo do organograma e do fluxograma). */
export interface FiguraEmpresa {
  id: string;
  nome: string;
  /** URL assinada, temporária. */
  url: string;
  mime_type: string;
  storage_path: string;
  bucket: string;
  criado_por: string | null;
  created_at: string;
}

const erro = <T,>(error: unknown, mensagem: string, data: T): ApiResponse<T> => ({
  success: false,
  error: error instanceof Error ? error.message : mensagem,
  data,
});

// `empresaId` é a empresa do desenho aberto: o backend só usa para superadmin (os demais ficam na empresa da sessão).
const comEmpresa = (endpoint: string, empresaId?: string | null) =>
  empresaId ? `${endpoint}?empresa_id=${encodeURIComponent(empresaId)}` : endpoint;

export const figurasService = {
  async listar(empresaId?: string | null): Promise<ApiResponse<FiguraEmpresa[]>> {
    try {
      return await apiClient.get<ApiResponse<FiguraEmpresa[]>>(comEmpresa('/figuras', empresaId));
    } catch (error) {
      return erro(error, 'Erro ao carregar figuras', []);
    }
  },

  async enviar(file: File, empresaId?: string | null): Promise<ApiResponse<FiguraEmpresa | null>> {
    try {
      const fd = new FormData();
      fd.append('imagem', file);
      return await apiClient.postMultipart<ApiResponse<FiguraEmpresa>>(comEmpresa('/figuras', empresaId), fd);
    } catch (error) {
      return erro(error, 'Erro ao enviar imagem', null);
    }
  },

  async remover(id: string, empresaId?: string | null): Promise<ApiResponse<boolean>> {
    try {
      return await apiClient.delete<ApiResponse<boolean>>(comEmpresa(`/figuras/${id}`, empresaId));
    } catch (error) {
      return erro(error, 'Erro ao remover figura', false);
    }
  },
};
